/**
 * @generated SignedSource<<451caaf5d387ff0e1bd72b5c6d397bb7>>
 * @relayHash 9ff0164f691a0cacd00cfdc1420b0637
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 6273c87c071f9520d41ac422175b91e089daa04f688233b11e5c561dba5f9a00

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { GlobalAccessManagementPageQuery } from './GlobalAccessManagementPageQuery.graphql';

const node: PreloadableConcreteRequest<GlobalAccessManagementPageQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "6273c87c071f9520d41ac422175b91e089daa04f688233b11e5c561dba5f9a00",
    "metadata": {},
    "name": "GlobalAccessManagementPageQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
